import { useContext } from "react";
import { IconButton, Button, Tooltip, Switch } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/img/logo_center.svg';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { ThemeContext } from '../styles/theme/ThemeProvider';

const Header = (props) => {  
  const { onDrawerToggle } = props;
  const { isDarkMode, setIsDarkMode } = useContext(ThemeContext)

  return (
    <header className='header'>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={onDrawerToggle}
      >
        <MenuIcon />
      </IconButton>
      <h1 className='project-tit'>
        <a href='/'>
          {/* {isDarkMode ? <img src={logoDarkMode} alt='Hanwha Aerospace' /> : <img src={logo} alt='Hanwha Aerospace' /> }            */}
          <img src={logo} alt='Mute Soyo' /> 
        </a>
      </h1>
      <Switch
        checked={isDarkMode}
        onChange={() => setIsDarkMode(prev => !prev)}
      />
    </header>
  );
};
export default Header;